<template>
    <b-card body-class="p-0" :title="$translate('filters')" class="text-center" title-tag="h5">
        <b-card-body class="p-0 query-filter">
            <b-row class="mt-12 text-start">
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('due_from') }}</strong></label>
                    <b-form-input type="date" id="input-due_from" :max="assetServiceFilter.due_to"
                        v-model="assetServiceFilter.due_from"></b-form-input>
                </b-col>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('due_to') }}</strong></label>
                    <b-form-input type="date" :min="assetServiceFilter.due_from" id="input-due_to"
                        v-model="assetServiceFilter.due_to"></b-form-input>
                </b-col>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('complete_from') }}</strong></label>

                    <b-form-input type="date" :max="assetServiceFilter.completion_date_to" id="input-completion-date_from"
                        v-model="assetServiceFilter.completion_date_from"></b-form-input>
                </b-col>

                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{ $translate('complete_to') }}</strong></label>
                    <b-form-input type="date" :min="assetServiceFilter.completion_date_from" id="completion-date_to"
                        v-model="assetServiceFilter.completion_date_to"></b-form-input>
                </b-col>
                <b-col cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>{{ $translate('activity_status') }}</strong></label>
                    <b-form-select id="input-status" class="form-control" v-model="assetServiceFilter.status"
                        value-field="id" text-field="name" :options="status">
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_status') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assets-servicequeryfilters',
    mixins: [permissionsMixins],

    props: ['value'],
    data() {
        return {}
    },
    computed: {
        status() {
            return [
                { id: 1, name: this.$translate('completed') },
                { id: 2, name: this.$translate('processing') },
                { id: 3, name: this.$translate('pending') },
            ]
        },
        assetServiceFilter: {
            get() {
                console.log('...........', this.value)
                return this.value
            },
            // setter
            set(val) {
                if (!val.checkoff_type_id) {
                    val.checkoff_completed = null
                }
                val.completion_date_from
                this.$emit('input', val)
            },
        },
        completedValues() {
            return [
                { value: null, text: 'Any' },
                { value: 1, text: 'Yes' },
                { value: 2, text: 'No' },
            ]
        },
        changedValues() {
            return [
                { value: null, text: 'All' },
                { value: 1, text: 'Changed' },
                { value: 2, text: 'Unchanged' },
            ]
        },
    },
    // created() {
    //     this.$store.dispatch('roles/fetchAll')
    // },
    mounted() {
        // this.$store.dispatch('orders/fetchDrivers')
        //init remote filters
    },
    methods: {},
}
</script>
